import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';

import { SmartForm, CTAButtons } from 'components';
import {
  getCompanyInfo,
  getCompanyDetails,
  editCompanyInfo,
} from 'rdx/company';
import {
  fetchAddresses,
  getAddressesByOwnerID,
  saveAddress,
} from 'rdx/addresses';

import { schema } from './schemas';

import './companyDetails.scss';

function CompanyDetails() {
  const dispatch = useDispatch();
  const refToFormik = React.useRef(null);

  const companyDetails = useSelector(getCompanyDetails);
  const companyAddress = useSelector(getAddressesByOwnerID(companyDetails.id));
  const address = companyAddress[0];

  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getCompanyInfo());
  }, [dispatch]);

  useEffect(() => {
    dispatch(fetchAddresses({ ownerID: companyDetails.id }));
  }, [companyDetails, dispatch]);

  const handleSubmit = async (route) => {
    await dispatch(
      saveAddress({
        ...address,
        ...refToFormik.current.values,
        ownerID: companyDetails.id,
      }),
    );

    await dispatch(
      editCompanyInfo({
        ...refToFormik.current.values,
      }),
    );

    return navigate(`${route}`);
  };

  const buttons = {
    close: { onClick: () => handleSubmit('/setup/general') },
    next: {
      onClick: () => handleSubmit('/setup/pos-locations'),
    },
  };
  return (
    <div className="flex-fill d-flex flex-column">
      <SmartForm
        ref={refToFormik}
        grid
        fields={schema}
        state={{ ...companyDetails, ...address }}
        handleSubmit={handleSubmit}
      />
      <CTAButtons buttons={buttons} />
    </div>
  );
}

export default CompanyDetails;
